import { NgModule, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerTableViewComponent } from '../customer/customer-table-view/customer-table-view.component';
import { CustomerDetailViewComponent } from './customer-detail-view/customer-detail-view.component';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { MatListModule } from '@angular/material/list';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LicenceDetailViewComponent } from './licence-detail-view/licence-detail-view.component';
import { Routes, RouterModule } from '@angular/router';
import { CustomerEditViewComponent } from './customer-edit-view/customer-edit-view.component';
import { MatStepperModule } from '@angular/material/stepper';
import { NguCarouselModule } from '@ngu/carousel';
import { MatTabsModule } from '@angular/material/tabs';
import { LicenceCarouselComponent } from './licence-detail-view/licence-carousel/licence-carousel.component';
import { LicenceCardComponent } from './licence-detail-view/licence-card/licence-card.component';
import { LicenceEditViewComponent } from './licence-edit-view/licence-edit-view.component';
import { MatSortModule } from '@angular/material/sort';
import { LOCALE_ID } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslatePaginatorService } from '../shared/translatePaginator/translate-paginator.service';
import { MatPaginatorIntl } from '@angular/material/paginator';

const routes: Routes = [
  {
    path: 'customer/detail/:customerId/:licenceId',
    component: LicenceDetailViewComponent,
    // canActivate: [IsAuthenticatedGuard]
  },
];

@NgModule({
  declarations: [
    CustomerTableViewComponent,
    CustomerDetailViewComponent,
    LicenceDetailViewComponent,
    CustomerEditViewComponent,
    LicenceCarouselComponent,
    LicenceCardComponent,
    LicenceEditViewComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    MatListModule,
    MatGridListModule,
    MatCheckboxModule,
    NguCarouselModule,
    MatTabsModule,
    RouterModule.forRoot(routes),
    MatStepperModule,
    MatSortModule,
    MatSlideToggleModule,
  ],
  exports: [RouterModule],
  providers: [
    {
      provide: MatPaginatorIntl,
      useClass: TranslatePaginatorService,
    }, {
      provide: LOCALE_ID,
      useValue: 'de'
    }
  ]
})
export class CustomerModule {}
